import React from 'react';

const styleBadge = {
  'padding': '6px 8px',
  'borderRadius': '2px',
  'fontSize': '100%',
  'width': '44px'
}

export default class MaintenanceTypeRow extends React.Component {
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this)
  }

  openModal() {
    const {RowData, setDataEdit} = this.props;
    setDataEdit(RowData)
  }

  renderBadgeQuick(RowData) {
    if(RowData.IsQuickTest === true) {
      return (<span className="badge badge-success" style={{...styleBadge}}>Yes</span>)
    }else if(RowData.IsQuickTest === false) {
      return (<span className="badge badge-danger" style={{...styleBadge}}>No</span>)
    } else {
      return (<span className="badge badge-default" style={{...styleBadge}}>-</span>)
    }
  }

  render() {
    const {RowData} = this.props
    return (
      <tr>
        <td>
          {RowData.Name}
        </td>
        <td>
          {RowData.Duration}   
        </td>
        <td>
          {RowData.Description}   
        </td>
        <td>
          {this.renderBadgeQuick(RowData)}
        </td>
        <td className="text-center">
          <button className="btn btn-4r btn-sm btn-primary" onClick={()=>this.openModal('modal_update')}><i className="icon-pencil"></i></button>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/master/maintenance_type/helper/component/MaintenanceTypeRow.js